import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomFormResponse } from '../models/responses/custom-form-response';
import { FormEntryResponse } from '../models/responses/form-entry-response';
import { environment } from '../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class FormEntryService {

  constructor(private httpClient: HttpClient) { }

  createForm(form: CustomFormResponse, formEntries: FormEntryResponse[]) {
    return this.httpClient.post(`${environment.formUrl}/create`, { form, formEntries });
  }

  upsertBatchEntries(formEntries: FormEntryResponse[], aiAgentId: number) {
    return this.httpClient.post(`${environment.formUrl}/upsert/batch`, { formEntries, businessId: aiAgentId });
  }

  deleteEntries(ids: number[]) {
    return this.httpClient.post(`${environment.formUrl}/delete/batch`, { ids });
  }
}
